import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import RtlLayout from "layouts/rtl";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import Home from './components/Home/Home.tsx'
import AddMember from "./components/Member/AddMember.jsx";
import AddUser from 'components/User/Adduser';
import Login from "components/User/Login.jsx";
import ViewLoan from "components/Loan/ViewLoan.jsx";
const App = () => {
  return (
    <Routes>
      <Route path="/" element={<Home/>}/>
        
      <Route path="auth/*" element={<AuthLayout />} />
      <Route path="admin/*" element={<AdminLayout />} />
      <Route path="/login" element={<Login/>}/>
    <Route path="addmembers" element={<AddMember/>}/>
    <Route path="adduser" element={<AddUser/>}/>
      <Route path="rtl/*" element={<RtlLayout />} />
      <Route path="/viewloan" element={<ViewLoan/>}/>
      <Route path="/" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
};

export default App;
